import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaRE/step4';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_454 } from '../../../validators/454/ctrl454';
import { TypeInfosRectif } from '../models/TypeInfosRectif';
import { MapaREControlNames } from '../services/mapaREControleNames';
@Component({
  selector: 'app-type-infos-rectif',
  templateUrl: './type-infos-rectif.component.html'
})
export class TypeInfosRectifComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeInfosRectif';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;

  @Input() infosRectif: TypeInfosRectif;

  public rg1 = '_STEP_ID_4_' + CTRL_454.id + '_1';

  public step4 = new Step4();

  public radioButtonValue1 = '';
  radioButtonCtrlName;
  lire = RadioCheckBoxEnum.lire;
  ajouter = RadioCheckBoxEnum.ajouter;
  supprimer = RadioCheckBoxEnum.supprimer;
  public optionsSelect: any[];
  public optionsSelectType = 'RUBRIQUE';

  constructor(private autoCompleteService: AutoCompleteService) { }

  public ngOnInit() {
    if (!this.infosRectif) {
      this.infosRectif = new TypeInfosRectif();
    }
    if (!this.infosRectif.rubDelais) {
      this.infosRectif.rubDelais = '';
    }
    if ((this.infosRectif.rubDelais !== null && this.infosRectif.rubDelais !== undefined && this.infosRectif.rubDelais !== '') ||
        (this.infosRectif.lireDate !== null && this.infosRectif.lireDate !== undefined && this.infosRectif.lireDate !== '')) {
      this.radioButtonValue1 = '';
    } else {
      this.radioButtonValue1 = null;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_ALS_RB';
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.parentForm.addControl(this.rg1, new FormControl({ rgCtrls: MapaREControlNames.getCtrl_454Names_json() }));
  }

  alsValue() {
    return this.parentForm.controls[this.radioButtonCtrlName]?.value;
  }

  rbValue() {
    return this.parentForm.controls[this.getUid() + '_SepAtt_RB'].value === RadioCheckBoxEnum.emptyValue;
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

